import { userService } from './service'
import { createFetchHook } from '../../acato-utils'

export const userServiceHooks = createFetchHook(userService)
